import { createReducer, createSelector } from '@reduxjs/toolkit'
import { retrieveLexicalCodes } from '../../core/use-cases/retrieveLexicalCodes'
import { AppState } from '../store'

type LexicalCodesState = {
  loading: boolean
  value: Record<string, string[]>
}

const initialState: LexicalCodesState = {
  loading: false,
  value: {},
}

export const lexicalCodesReducer = createReducer(initialState, builder => {
  builder.addCase(retrieveLexicalCodes.pending, state => {
    state.loading = true
    state.value = {}
  })
  builder.addCase(retrieveLexicalCodes.fulfilled, (state, action) => {
    state.loading = false
    state.value = action.payload
  })
})

export const selectLexicalCodes = (state: AppState) => state.lexicalCodes.value
export const selectLexicalValues = (code: string) =>
  createSelector(selectLexicalCodes, state => {
    if (code == null) {
      return []
    }

    return state[code]
  })
